import reactUpdate from 'immutability-helper';
import _ from 'underscore';

// If a note part is part of a numbered list, returns the index in the list
import * as benchlingUtil from 'BenchlingUtil';
import NoteConstants from 'notebook/notes/NoteConstants';
import {NoteDay, NotePart} from 'notebook/util/NoteUtilConstants';

import {ListType, MAX_INDENTATION} from './ListConstants';

export default function updateCalculatedIndices(
  noteParts: Array<NotePart>,
  days?: Array<NoteDay>
): Array<NotePart> {
  if (days == null) {
    days = [];
  }
  const numberedLevels = benchlingUtil.repeat([0], MAX_INDENTATION + 1);

  function clearNumbered(indentLevel: number): void {
    for (
      let i = indentLevel, end = numberedLevels.length, asc = indentLevel <= end;
      asc ? i < end : i > end;
      asc ? i++ : i--
    ) {
      numberedLevels[i] = 0;
    }
  }

  // eslint-disable-next-line no-restricted-syntax
  const dayIndices = _.pluck(days, 'index');

  // eslint-disable-next-line no-restricted-syntax
  const newNoteParts = _.map(noteParts, (notePart, index) => {
    // Clear the numbering and indentations on the first notePart of a day
    // section.
    let calculatedListIndex: number | null;
    // eslint-disable-next-line no-restricted-syntax
    if (_.indexOf(dayIndices, index) >= 0) {
      clearNumbered(0);
    }
    if (
      [ListType.BULLET, ListType.CHECKBOX_CHECKED, ListType.CHECKBOX_UNCHECKED].includes(
        notePart.listType as ListType
      )
    ) {
      calculatedListIndex = null;
      clearNumbered(notePart.indentation);
    } else if (notePart.listType !== ListType.NUMBER) {
      // Don't restart numbering if the line is blank
      if (notePart.type !== NoteConstants.TEXT || notePart.text.length > 0) {
        clearNumbered(notePart.indentation + 1);
      }
      calculatedListIndex = null;
    } else {
      calculatedListIndex = numberedLevels[notePart.indentation];
      numberedLevels[notePart.indentation] += 1;
      clearNumbered(notePart.indentation + 1);
    }

    if (notePart.calculatedListIndex !== calculatedListIndex) {
      return reactUpdate(notePart, {$merge: {calculatedListIndex}});
    }
    return notePart;
  });

  return newNoteParts;
}
